import { render, staticRenderFns } from "./DadosVeiculoTerceiroForm.vue?vue&type=template&id=8401f078&scoped=true"
import script from "./DadosVeiculoTerceiroForm.vue?vue&type=script&lang=js"
export * from "./DadosVeiculoTerceiroForm.vue?vue&type=script&lang=js"
import style0 from "./DadosVeiculoTerceiroForm.vue?vue&type=style&index=0&id=8401f078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8401f078",
  null
  
)

export default component.exports